import { IFolderModel } from 'models/folder.model'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faGripLines } from '@fortawesome/pro-solid-svg-icons'
import styles from './Folder.module.scss'
import { useTranslation } from 'react-i18next'
import { advancedOrder } from 'enum/folder.enum'
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd'
import { ICourseModel } from 'models/course.model'

type CoursesProps = {
  item: IFolderModel
  onSelectedCourseClickDefault: (courseId: string | number) => void
  onOrderChange: (courses: ICourseModel[]) => void
  courses: ICourseModel[]
}

export function Courses({
  item,
  onSelectedCourseClickDefault,
  onOrderChange,
  courses,
}: CoursesProps) {
  const { t } = useTranslation()
  const { sortSettings } = item
  const haveCustomOrder = sortSettings?.fields?.some(
    (field) => field.attribute === advancedOrder
  )

  const reorder = (
    list: ICourseModel[],
    startIndex: number,
    endIndex: number
  ) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    return result
  }

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return
    }
    const items = reorder(
      courses,
      result.source.index,
      result.destination.index
    )
    onOrderChange(items)
  }

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {courses.map((course, index) => (
                <Draggable
                  key={course.id}
                  draggableId={`${course.id}`}
                  index={index}
                  isDragDisabled={!haveCustomOrder}
                >
                  {(provided) => (
                    <div
                      key={course.id}
                      className={styles.itemCourse}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <div className="d-flex align-items-center">
                        {haveCustomOrder && (
                          <div className="mr-3">
                            <FontAwesomeIcon
                              size="1x"
                              color="#808080"
                              icon={faGripLines}
                              className="mr-2"
                            />
                          </div>
                        )}
                        <div className="d-flex flex-column">
                          <span>{course.name}</span>
                          <div className="text-muted">
                            {t('administration.folders.folder.subtitle')}
                            {course.requiredProfiles?.map(
                              (element: any) => ` ${element.name} `
                            )}
                            {course.optionalProfiles?.map(
                              (element: any) => ` ${element.name} `
                            )}
                          </div>
                        </div>
                      </div>
                      {item.id != 1 && (
                        <FontAwesomeIcon
                          onClick={() =>
                            course.id && onSelectedCourseClickDefault(course.id)
                          }
                          size="1x"
                          color="#808080"
                          role="button"
                          icon={faTimes}
                          className="my-2"
                        />
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  )
}
